import AsyncStorage from '@react-native-async-storage/async-storage';

export const setStateToStorage = state => AsyncStorage.setItem('@state', JSON.stringify(state))
export const getStateFromStorage = async () => {
  const storedValue = await AsyncStorage.getItem('@state')
  return storedValue ? JSON.parse(storedValue) : null
}

export const setSFXVolumeToStorage = volume => AsyncStorage.setItem('@SFXVolume', JSON.stringify(volume))
export const getSFXVolumeFromStorage = async () => {
  const storedValue = await AsyncStorage.getItem('@SFXVolume')
  return storedValue ? JSON.parse(storedValue) : 0.5
}

export const setMFXVolumeToStorage = volume => AsyncStorage.setItem('@MFXVolume', JSON.stringify(volume))
export const getMFXVolumeFromStorage = async () => {
  const storedValue = await AsyncStorage.getItem('@MFXVolume')
  return storedValue ? JSON.parse(storedValue) : 0.5
}